var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPngInActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "63px",
    viewBox: "0 0 51 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "article-/-images-_input-2",
    transform: "translate(-274.000000, -51.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30A2\\u30C3\\u30D7\\u30ED\\u30FC\\u30C9\\u9818\\u57DF",
    transform: "translate(13.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PNG",
    transform: "translate(261.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.875,0 L6.375,0 C2.86875,0 0.031875,2.835 0.031875,6.3 L0,56.7 C0,60.165 2.836875,63 6.343125,63 L44.625,63 C48.13125,63 51,60.165 51,56.7 L51,18.9 L31.875,0 Z M28.6875,22.05 L28.6875,4.725 L46.21875,22.05 L28.6875,22.05 Z",
    id: "Shape",
    fill: "#979797",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: ".PNG",
    fontFamily: "Helvetica",
    fontSize: 18,
    fontWeight: "normal",
    letterSpacing: 0.9,
    fill: "#F1F1F1"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.19658203,
    y: 44
  }, ".PNG"))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPngInActive);
export default __webpack_public_path__ + "static/media/PngInActive.d0f0247ff3268c679947c1121d38d41e.svg";
export { ForwardRef as ReactComponent };